import { Container, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    height: "auto",

    paddingLeft: "110px",
    paddingRight: "110px",
    marginTop: "-200px",
    marginBottom: "80px",

    [theme.breakpoints.between("lm", "lm")]: {
      paddingLeft: "30px",
      paddingRight: "30px",
    },
    [theme.breakpoints.between("md", "md")]: {
      paddingLeft: "20px",
      paddingRight: "20px",
      marginTop: "-150px",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "-100px",
      padding: "0 0",
    },
  },
  title: {
    marginBottom: "40px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "20px",
    },
  },
}));
export default function DaikukoContainer({ children, title, maxWidth = "lg" }) {
  const classes = useStyles();
  return (
    <Container maxWidth={maxWidth} className={classes.container}>
      <Typography className={classes.title} color="primary" variant="h1">
        {title}
      </Typography>
      {children}
    </Container>
  );
}
